<template>
    <v-layout column justify-center align-center pa-4>
      <v-card class="password-wrap pa-4 mb-4" v-if="!invalid">
        <v-alert
          color="error"
          class="err"
          icon="warning"
          value="true"
          v-if="err">{{err}}
        </v-alert>
        <h3>{{$lang.actions.enterPassword}}</h3>
        <v-form v-model="valid" @submit.native.prevent="setPassword()">
          <v-text-field
            :label="$lang.actions.newPassword"
            v-model="password"
            name="password"
            type="password"
            :rules="passwordRules"
            required
          ></v-text-field>
          <v-text-field
            :label="$lang.actions.confirmPassword"
            v-model="confirmPassword"
            name="password"
            type="password"
            :rules="passwordRules"
            required
          ></v-text-field>
          <v-btn
            :disabled="!valid"
            color="primary"
            type="submit"
            class="ma-0">{{$lang.actions.submit}}</v-btn>
        </v-form>
      </v-card>
      <v-card class="password-wrap pa-4 mb-4" v-else>
        <v-alert
          color="error"
          class="err"
          icon="warning"
          value="true"
          v-if="err">{{err}}
        </v-alert>
      </v-card>
    </v-layout>
</template>

<script>
  import auth from '../../auth';

  export default {
    data() {
      return {
        valid: false,
        password: '',
        confirmPassword: '',
        invalid: false,
        passwordRules: [
          v => !!v || this.$lang.errors.requiredPassword,
          v => (v && v.length >= 6 && v.length <= 35) || this.$lang.errors.passwordConditions,
        ],
        err: '',
      };
    },
    methods: {
      setPassword() {
        if (this.password !== this.confirmPassword) {
          this.err = this.$lang.errors.matchPasswords;
          return;
        }
        this.$webHelper.post('user/submitpassword', {
          activationId: this.$route.params.hash,
          password: this.password,
        }, this.$router)
          .then((res) => {
            if (!res.success) {
              this.err = this.$lang.errors.failedPassword;
              return;
            }
            auth.manualLogin(res.body.uuid);
            this.$router.push({ name: 'webShop', query: { passwordSet: true } });
          });
      },
    },
    created() {
      if (!this.$route.params.resourceId || !this.$route.params.hash) {
        this.$router.push({ name: 'webShop' });
        return;
      }
      this.$webHelper.post('activation/activateuser', { activationId: this.$route.params.hash }, this.$router)
        .then((res) => {
          if (!res.success) {
            this.err = this.$lang.errors.invalidKey;
            this.invalid = true;
          }
        });
      this.$storage.catalog = null;
      this.$storage.order = null;
      this.$store.dispatch('clearCart');
      this.$storage.company = null;
      this.$store.dispatch('setCompany', null);
      localStorage.setItem('webShopResourceId', this.$route.params.resourceId);
      this.$webHelper.get(`webshopresource/fetchbyexternalid/${this.$route.params.resourceId}`, null, this.$router)
        .then((res) => {
          if (!res.success) {
            this.err = this.$lang.errors.failedCompany;
            return;
          }
          const companyData = Object.assign({}, res.body.company, res.body.webShopResource);
          this.$storage.company = companyData;
          this.$store.dispatch('setCompany', companyData);
        });
    },
  };
</script>

<style lang="scss" scoped>
  .password-wrap {
    min-width: 300px;
    width: 100%;
    max-width: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Activate.vue